// LogoSwitcher.jsx
import React, { useState } from 'react'
import SvgIcon from '../components/common/SvgIcon.js'

export default function LogoSwitcher({
  main,     
  alt,     
  color,
  hoverColor,
  size,
  className,
}) {
  const [isHover, setIsHover] = useState(false)

  return (
    <div
      className="logo-wrapper"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{ width: size, height: size }}        /* lock the container size */
    >
      {/* default icon */}
      <SvgIcon
        src={main}
        color={color}
        size={size}
        className={`${className} logo-main`}
        style={{ opacity: isHover ? 0 : 1 }}
      />

      {/* hover icon */}
      <SvgIcon
        src={alt}
        color={hoverColor}
        size={size}
        className={`${className} logo-alt`}
        style={{ opacity: isHover ? 1 : 0 }}
      />
    </div>
  )
}
